import { useEffect, useState } from "react";
import { cassa } from "./cassaApi";

let cache = null;
const subs = new Set();
export const loadColors = () => cassa.get("/colors").then((r) => { cache = r.data; subs.forEach((f) => f(cache)); return cache; });
export function useColors() {
  const [c, setC] = useState(cache);
  useEffect(() => { subs.add(setC); if (!cache) loadColors().catch(() => {}); return () => subs.delete(setC); }, []);
  return c || { cats: [], counts: {} };
}

const lum = (hex) => {
  const v = (hex || "#ffffff").replace("#", "");
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(v.slice(i, i + 2), 16) / 255).map((x) => (x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4));
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
export const textOn = (bg) => (lum(bg) > 0.45 ? "#0f172a" : "#ffffff");

export function styleOf(p, cats) {
  const fill = cats.find((c) => c.key === p.cf && c.level === "fill" && c.active);
  const badge = cats.find((c) => c.key === p.cb && c.level === "badge" && c.active);
  return { fill, badge, style: { background: fill?.bg || "#ffffff", color: textOn(fill?.bg || "#ffffff"), borderColor: badge?.border || fill?.border || "#e2e8f0", borderWidth: badge ? 3 : 1 } };
}

const Dot = ({ c, ring }) => <span className="inline-block w-3 h-3 rounded-full" style={{ background: c, boxShadow: ring ? "0 0 0 1px #fff" : undefined }} />;
export function Symbol({ cat }) {
  if (!cat || cat.symbol === "none") return null;
  if (cat.symbol === "text") return <span className="text-[11px] font-bold px-1.5 py-0.5 rounded" style={{ background: cat.bg, color: textOn(cat.bg) }}>{cat.text || cat.name}</span>;
  if (cat.symbol === "dot") return <Dot c={cat.border} ring />;
  const black = <Dot c="#111" ring />;
  const cmy = <span className="inline-flex -space-x-1"><Dot c="#00AEEF" ring /><Dot c="#EC008C" ring /><Dot c="#FFF200" ring /></span>;
  return <span className="inline-flex items-center gap-1" title={cat.name}>{cat.symbol !== "cmy" && black}{cat.symbol !== "black" && cmy}</span>;
}

export function Legend() {
  const { cats } = useColors();
  const [open, setOpen] = useState(false);
  return (
    <span className="relative">
      <button data-testid="cassa-colors-legend-btn" onClick={() => setOpen(!open)} className="press h-8 w-8 rounded-full border bg-white font-bold text-sm" title="Legenda colori">?</button>
      {open && (
        <div data-testid="cassa-colors-legend" className="absolute z-30 right-0 mt-2 w-64 rounded-lg border bg-white shadow-lg p-3 space-y-1.5 text-[13px]">
          {cats.filter((c) => c.active).map((c) => (
            <div key={c.key} className="flex items-center gap-2">
              <span className="w-6 h-5 rounded" style={{ background: c.level === "fill" ? c.bg : "#fff", border: `${c.level === "badge" ? 3 : 1}px solid ${c.border}` }} />
              <span className="flex-1">{c.name}</span><Symbol cat={c} />
            </div>
          ))}
        </div>
      )}
    </span>
  );
}

const PREF = "hs_cassa_view";
export function useViewPrefs() {
  const [v, setV] = useState(() => { try { return { dense: false, scale: 1, ...JSON.parse(localStorage.getItem(PREF) || "{}") }; } catch { return { dense: false, scale: 1 }; } });
  const set = (p) => setV((o) => { const n = { ...o, ...p }; localStorage.setItem(PREF, JSON.stringify(n)); return n; });
  return [v, set];
}
